import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../constants';

const PreactivationList = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <div className="PreactivationList">
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>MDN</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Edited</th>
            <th>Created At</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 &&
            data.map((preactivation) => (
              <tr key={preactivation.id}>
                <td>{preactivation.id}</td>
                <td>{preactivation.mdn}</td>
                <td>{preactivation.first_name}</td>
                <td>{preactivation.last_name}</td>
                <td>
                  {preactivation.old_account_number &&
                    preactivation.old_pin && (
                      <span className="glyphicon glyphicon-ok text-success"></span>
                    )}
                </td>
                <td>
                  {moment(preactivation.created_at).format(DATE_TIME_FORMAT)}
                </td>
                <td>
                  <Link to={`/preactivations/${preactivation.id}/view`}>
                    View
                  </Link>
                </td>
              </tr>
            ))}
          {data.length === 0 && (
            <tr>
              <td colSpan="6">No preactivations</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PreactivationList;
